<template>
  <div class="form-field"/>
</template>

<script>
export default {
  name: 'ValidatedField',
  methods: {
    onFocus (e) {
      this.$emit('focus', e)
      this.$v.$reset()
    },
    onBlur (e) {
      this.$emit('blur', e)
      this.$v.$touch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/ValidatedField.vue